import React from 'react';
import './Quotation.scss';

export default function Quotation({quotation}) {
    return <div className='quotation'>
        <div className='background' style={{backgroundImage: 'url(' + process.env.PUBLIC_URL + '/images/flower.jpg' + ')'}}></div>
        <p>{quotation}</p>
    </div>
}